// extracted by mini-css-extract-plugin
module.exports = {"container":"AddDialog_container_2oZaF","buttonWrap":"AddDialog_buttonWrap_2kNeQ"};